<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <li class="active">設定</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>設定</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <div class="alert alert-danger" v-if="errorMessageLogs">
                  {{ errorMessageLogs }}
                </div>
                <div class="alert alert-success" v-if="sucessStatus">
                  {{ sucessStatus }}
                </div>
                <h3>
                  二段階認証設定
                </h3>
                <p>SMS認証の設定を変更して電話番号を入力してください。</p>
                <!-- PAGE CONTENT BEGINS -->
                <ul class="none-list">
                  <li>
                    <label class="clearfix">
                      <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px">SMS認証</div>
                      <div class="profile-info-value">
                          <input name="switch-field-1" :disabled="isMfa === 'false'" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isMfaSms">
                          <span class="lbl"></span>
                      </div>
                    </label>
                  </li>
                  <li>
                    <span id="phonenumber_error" class="error_m"></span>
                    <label class="clearfix">
                      <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px">電話番号</div>
                      <div class="profile-info-value" style="width: 70%">
                          <input id="phonenumber" type="text" class="input form-control input-sm" :disabled="!allowSubmit" v-model="userInfor.phoneNumber" @blur="validateBeforeSubmit(2)">
                      </div>
                    </label>
                  </li>
                  <li>
                    <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"></div>
                      <div class="profile-info-value" style="width: 75%;padding-top:0px">
                      <span> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。 </span>
                      </div>
                    </li>
                  <div class="clearfix">
                    <button class="btn btn-info" type="submit" :disabled="isMfa === 'false'" style="padding-left: 20px;padding-right: 20px;" @mousedown="submitConfig">
                    登録
                    </button>
                  </div>
                </ul>
              </div>
                <!-- PAGE CONTENT ENDS -->
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
    </div><!-- /.main-content -->
  </div>
</template>
<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      allowSMS: false,
      isMfa: 'false',
      allowSubmit: false,
      sucessStatus: '',
      loading: false,
      userInfor: {
        isMfaSms: false,
        phoneNumber: ''
      },
      errorMessageLogs: ''
    }
  },
  watch: {
    'userInfor.isMfaSms': function (newVal, oldVal) {
      $('.error_m').html('')
      $('.input').removeClass('error')
      this.allowSubmit = newVal
    }
  },
  mounted () {
    this.getInforUser()
    return this.getPlan()
      .then(() => {
        this.isMfa = localStorage.isMfa
      })
  },
  methods: {
    getInforUser () {
      var vm = this
      vm.errorMessageLogs = ''
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(localStorage.userProfileId))
        .then(response => {
          console.log(response)
          vm.userInfor.isMfaSms = response.body.users[0].isMfaSms
          vm.userInfor.phoneNumber = response.body.users[0].phoneNumber
          vm.userInfor.phoneNumber = vm.userInfor.phoneNumber.replace('+81', '0')
        })
        .catch(error => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    editConfig () {
      this.loading = true
      this.errorMessageLogs = ''
      this.sucessStatus = ''
      const encodedUserId = encodeURIComponent(encodeURIComponent(localStorage.userProfileId))
      var OuserInforSelft = {}
      OuserInforSelft.isMfaSms = this.userInfor.isMfaSms
      if (this.userInfor.isMfaSms === true) {
        var phone = this.userInfor.phoneNumber.substring(1)
        OuserInforSelft.phoneNumber = '+81' + phone
      }
      this.$http.put(Config.USERS_LIST_API + '/' + encodedUserId, JSON.stringify(OuserInforSelft))
        .then(response => {
          this.loading = false
          this.sucessStatus = 'SMS認証の設定が変更されました。'
        })
        .catch((error) => {
          this.sucessStatus = ''
          this.loading = false
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    submitConfig () {
      if (this.validateBeforeSubmit(-1)) {
        this.editConfig()
      }
    },
    validateBeforeSubmit (index) {
      var isValid = true
      this.sucessStatus = ''
      if (this.userInfor.isMfaSms) {
        if (this.userInfor.phoneNumber !== null && this.userInfor.phoneNumber.trim() !== '') {
          if (!this.userInfor.phoneNumber.match(/^[0][0-9]{10}$/)) {
            if (index === -1 || index === 2) {
              $('#phonenumber_error').html('入力された電話番号は無効です。<br> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
              $('#phonenumber').addClass('error')
            }
            isValid = false
          } else {
            if (index === -1 || index === 2) {
              $('#phonenumber_error').html('')
              $('#phonenumber').removeClass('error')
            }
          }
        } else {
          if (index === -1 || index === 2) {
            if (!this.userInfor.isMfaSms) {
              $('#phonenumber_error').html('')
              $('#phonenumber').removeClass('error')
            } else {
              $('#phonenumber_error').html('入力された電話番号は無効です。<br> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
              $('#phonenumber').addClass('error')
              isValid = false
            }
          }
        }
      }
      // if (this.userInfor.isMfaSms) {
      //   if (this.userInfor.phoneNumber.trim() === '') {
      //     if (index === -1) {
      //       $('#phonenumber_error').html('0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
      //       $('#phonenumber').addClass('error')
      //     }
      //     isValid = false
      //   } else {
      //     if (index === -1) {
      //       $('#phonenumber_error').html('')
      //       $('#phonenumber').removeClass('error')
      //     }
      //   }
      // }
      return isValid
    },
    getPlan () {
      return new Promise((resolve, reject) => {
        localStorage.setItem('isMfa', false)
        localStorage.setItem('isFederatedLoginService', false)
        this.$http.get(Config.PLAN_API)
          .then((response) => {
            if (response.body.maxRecords > 0) {
              localStorage.setItem('isMfa', response.body.plans[0].isMfa)
              localStorage.setItem('isFederatedLoginService', response.body.plans[0].isFederatedLoginService)
            }
            resolve()
          }).catch((error) => {
            console.log(error)
            resolve()
          })
      })
    }
  }
}
</script>
<style>
input[type=checkbox].ace.ace-switch+.lbl::before {
    text-indent: 25px!important;
    content: "\7121\52B9"!important;
}
input[type=checkbox].ace.ace-switch:checked+.lbl::before {
    text-indent: 5px!important;
    content: "\6709\52B9"!important;
}
.none-list div{
  border: none;
}
.none-list {
  margin: 0px
}
.none-list li{
  list-style: none
}
</style>



// WEBPACK FOOTER //
// src/views/user/Configuration.vue